// extracted by mini-css-extract-plugin
var _1 = "yLMeTSKvP0Gz3nIbProi";
export { _1 as "task-list" }
